import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem, StyledTable } from "./Components";

import gen_haz_lev from "../img/sswpIcons/OtherItems/gen_oth_haz_lev.png";
import gen_deg_pur from "../img/sswpIcons/OtherItems/gen_de_gas_emp.png";
import gen_eme_pro from "../img/sswpIcons/OtherItems/gen_emg_pro.png";
import gen_fir_con_ass from "../img/sswpIcons/OtherItems/gen_fir_con_ass.png";
import gen_gro_con from "../img/sswpIcons/OtherItems/gen_fir_gro.png";
import gen_hou from "../img/sswpIcons/OtherItems/gen_oth_hou.png";
import gen_lig from "../img/sswpIcons/OtherItems/gen_lig.png";
import gen_str_str_dra from "../img/sswpIcons/OtherItems/gen_dra_str_str.png";
import gen_ani_det from "../img/sswpIcons/OtherItems/gen_ani_det.png";
import gen_boi_bur_tra from "../img/sswpIcons/OtherItems/gen_bio_bur_tra.png";
import gen_oth_san from "../img/sswpIcons/OtherItems/gen_oth_san.png";
import gen_oth_wea from "../img/sswpIcons/OtherItems/gen_oth_wea.png";
import gen_saf_sto from "../img/sswpIcons/OtherItems/gen_saf_sto.png";
import gen_sit_spe_met from "../img/sswpIcons/OtherItems/gen_sit_spe_met.png";
import gen_war_sig from "../img/sswpIcons/OtherItems/gen_war_sig.png";
import gen_was_man from "../img/sswpIcons/OtherItems/gen_was_man.png";

const json = {
    icon: gen_haz_lev,
    name: "General/Other Items",
    text: "",
    icons: {
        gen_oth_wea: {
            name: "Weather",
            icon: gen_oth_wea,
            text: (
                <ul>
                    <Li>
                     <Typography variant="title">
                     Windy Weather, it may be necessary to 
                        </Typography>
                    <ol>
                    <ListItem text="Cease working at height operations." />
                    <ListItem text="Remove loose material, or tie them down to prevent blowing off or falling." />
                    <ListItem text="Stop working where tools are being blown off (e.g. brick laying)." />
                    <ListItem text="Cranes must NOT be operated at wind speeds above those specified by the manufacturer." />
                    </ol>
                    <Typography variant="title">
                    Foggy Weather/heavy precipitation hampering vision, it may be necessary to
                        </Typography>
                        <ol>
                    <ListItem text="Cease works requiring traffic management, if minimum visibility requirements cannot be met." />
                    <ListItem text="Cease crane or lifting operations requiring signalling/ vision." />
                    </ol>
                    <Typography variant="title">
                    Icy Weather, it may be necessary to
                        </Typography>
                        <ol>
                    <ListItem text="Cease working at height operations ." />
                    <ListItem text="Cease roadwork operations, or other works where plant is being used." />
                    <ListItem text="Provide thermal clothing to prevent hypothermia. Also drink plenty of fluids, preferably warm, sweet beverages." />
                    </ol>
                    <Typography variant="title">
                    Sun low on the horizon/Sun Dazzle, it may be necessary to 
                        </Typography>
                        <ol>
                    <ListItem text="Cease works requiring traffic management, if minimum visibility requirements cannot be met." />
                    <ListItem text="Cease crane or lifting operations requiring signalling/ vision." />
                    </ol>
                    <Typography variant="title">
                    Hot sunny weather, consider 
                        </Typography>
                        <ol>
                    <ListItem text="Sun protection, sunblock, light full length garments, hats or head gear." />
                    <ListItem text="Drinking water for dehydration." />
                    </ol>
                    </Li>
                </ul>
            )
        },
        gen_oth_hou: {
            name: "Housekeeping",
            icon: gen_hou,
            text: (
                <ul>
                  
                    <ListItem text="Accessways must be kept clear of tools, plant, equipment, materials, rubbish or detritus materials/dirt & muck. Bins need to be provided and used." />
                    <ListItem text="Slip, trip and fall hazards need to be removed." />
                    <ListItem text="Protruding nails, screws or other sharp object need to be removed." />
                    <ListItem text="The storage of tools and materials needs to be organised and all operatives need to store items in their designated place." />
                    
                </ul>
            )
        },
        gen_oth_san: {
            name: "Sanitizer",
            icon: gen_oth_san,
            text: (
                <ul>
                    <ListItem text="Sanitizer should be used if running water or soap is not available on site. Soap and water is still the most effective method of removing most contaminants/ germs/ microbes. Sanitizer is not effective with heavy soiled hands, and is not good at removing chemical type contaminants like pesticides and heavy metals." />
                    <ListItem text="It should contain at least 60% alcohol." />
                    <ListItem text="Remove rings and apply sanitizer separately to their surfaces." />
                    <ListItem text="Apply the product to the palm of one hand and rub the product all over the surfaces of our hands, wrists, between fingers and back of hand, until your hands are dry." />
                </ul>
            )
        },
        gen_war_sig: {
            name: "Warning Signs",
            icon: gen_war_sig,
            text: (
                <ul>
                    <ListItem text="Signs will alert workers/public that they are approaching high-risk areas (e.g. exclusion zones, fall risks etc)." />
                    <ListItem text="Signs should use standardised graphical pictograms to communicate the hazard and may have supplementary information in written format." />
                    <Li>
                        <Typography variant="title">
                            Graphical symbols should NOT be combined to convey
                            more than one safety message. E.g. separate symbols
                            for hard hat and eye protection.
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Sign Type</th>
                                    <th>Meaning</th>
                                    <th>Shape & Colour</th>
                                </tr>
                                <tr>
                                    <td>Prohibition</td>
                                    <td>Not permitted</td>
                                    <td>
                                        <ul>
                                            <li>Shape: Round </li>
                                            <li>Backing colour: White</li>
                                            <li>
                                                Symbol colour: Black with red
                                                diagonal
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Fire fighting</td>
                                    <td>Location and identification of type</td>
                                    <td>
                                        <ul>
                                            <li>Shape: Rectangle </li>
                                            <li>Backing colour: Red</li>
                                            <li>Symbol colour: White</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Warning</td>
                                    <td>Take precaution</td>
                                    <td>
                                        <ul>
                                            <li>Shape: Triangle</li>
                                            <li> Backing colour: Yellow</li>
                                            <li> Symbol colour: Black</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Mandatory</td>
                                    <td>You Must</td>
                                    <td>
                                        <ul>
                                            <li>Shape: Round</li>
                                            <li> Backing colour: Blue</li>
                                            <li> Symbol colour: White</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Emergency escape</td>
                                    <td>Escape route</td>
                                    <td>
                                        <ul>
                                            <li>Shape: Rectangle </li>
                                            <li>Backing colour: Green</li>
                                            <li>Symbol colour: White</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Supplementary Information</td>
                                    <td>Additional Info</td>
                                    <td>
                                        <ul>
                                            <li>Shape: Rectangle</li>
                                            <li> Backing colour: White</li>
                                            <li> Symbol colour: Black</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Obstacles</td>
                                    <td>Collision risk</td>
                                    <td>
                                        <ul>
                                            <li>Chevron</li>
                                            <li> Black/Yellow </li>
                                            <li>Red/White</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Traffic Route</td>
                                    <td>Vehicles to keep between</td>
                                    <td>Continuous white or yellow lines.</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                </ul>
            )
        },
        gen_dra_str_str: {
            name: "Street Structure Drawings",
            icon: gen_str_str_dra,
            text: (
                <ul>
                    <ListItem text="If the location of services are not known on site, the relevant utility company must be contacted to obtain drawings and advice on the position of underground and overhead services." />
                    <ListItem text="Planned work will generally be accompanied by drawings. Such drawings should identify notes about any relevant safety procedures or method statements." />
                </ul>
            )
        },
        gen_emg_pro: {
            name: "Emergency Procedures",
            icon: gen_eme_pro,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            {" "}
                            The site should have a written emergency response
                            procedure. This will cover
                        </Typography>
                        <ol>
                            <ListItem text="Evacution" />
                            <ListItem text="Notification to emergency services" />
                            <ListItem text="Ensuring safe access routes for arriving emergency services" />
                            <ListItem text="First Aid" />
                            <ListItem text="Controlling access to area" />
                            <ListItem text="Rescue arrangements" />
                            <ListItem text="Environmental protection" />
                            <ListItem text="Fire protection and fire fighting arrangements and procedures" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        gen_fir_con_ass: {
            name: "Fire Control/ Assembly",
            icon: gen_fir_con_ass,
            text: (
                <ul>
                    <ListItem text="Where selected, should include fire detection, emergency lighting and alarm systems" />
                    <ListItem text="Bar heaters should not be used and naked flames tightly controlled" />
                    <ListItem text="Flammable materials stored separately in well-ventilated lockable location away from ignition sources." />
                    <ListItem text="Checks should be carried out after completion of hot works, to detect possible fires." />
                    <ListItem text="Sand or fire blankets may be provided where appropriate." />
                    <ListItem text="Bonfires or burning detritus material is not permitted." />
                    <ListItem text="All operatives must receive instruction on what to do in the event of fire, where the escape route is, and where the fire assembly points are located." />
                    <ListItem text="Fire drills should be held regularly, and the method of ensuring an accurate roll call at the fire assembly point established." />
                </ul>
            )
        },
        gen_gro_con: {
            name: "Firm Ground",
            icon: gen_gro_con,
            text: (
                <ul>
                    <ListItem text="This must be assessed by a person with the proper mix of training, knowledge and experience. If the conditions are beyond the competence of the person, then expert advice must be sought." />
                    <ListItem text="The ground on which any plant, scaffold, or other equipment is to be used must be assessed to ensure it is capable of bearing the required load." />
                    <ListItem text="Preparation work on the ground may be required before the task can commence. If this is the case, then this work must be completed prior to the task, and the ground conditions re-assessed." />
                    <ListItem text="Ground must be level." />
                    <ListItem text="Loads cannot be placed closer to excavations edges than the excavation is deep in good ground/weather conditions. In poor ground/weather conditions this distance needs to be increased." />
                </ul>
            )
        },
        gen_bio_bur_tra: {
            name: "Boilers / Burners / Training Services",
            icon: gen_boi_bur_tra,
            text: (
                <ul>
                    <ListItem text="Ensure you have read and follow the Safety Data Sheet of the material you are using" />
                    <ListItem text="Check condition of equipment and pipes. Ensure ground is stable and level." />
                    <ListItem text="Any boiler should be thermostatically controlled. Never leave a boiler unattended." />
                    <ListItem text="You must have either Dry Powder or Carbon Dioxide Fire Extinguisher." />
                    <ListItem text="Gas vapour from cylinders may ignite at a distant ignition source and flash back" />
                    <ListItem text="Ensure the area is well ventilated, and avoid breathing fumes" />
                    <ListItem text="Keep other workers/ public away from this type of work" />
                    <ListItem text="Use impervious gauntlet type gloves, full face protection, impervious overalls, and impervious safety footwear." />
                    <ListItem text="Do NOT transport above 100 degrees Celcius." />
                    <ListItem text="Before transport, check all valves are off and all items are secure." />
                    <ListItem text="Do NOT ladle from the boiler lid" />
                </ul>
            )
        },
        gen_ani_det: {
            name: "Animal Detterrants",
            icon: gen_ani_det,
            text: (
                <ul>
                    <ListItem text="Animal behaviour should be considered unpredictable (despite what the animal owner might say)" />
                    <ListItem text="Try to make sure the property owner knows you are there, e.g. rattle the gate" />
                    <ListItem text="If you are unsure, do not put yourself at risk" />
                    <Li>
                        <Typography variant="title">
                            If you find yourself confronted, by an animal
                        </Typography>
                        <ol>
                            <ListItem text="Don’t make eye contact" />
                            <ListItem text="Keep the animal in your peripheral vision" />
                            <ListItem text="Act as relaxed as possible" />
                            <ListItem text="Back away slowly, do not make sudden movements" />
                            <ListItem text="Walk away slowly with head and eyes down" />
                            <ListItem text="Do not turn your back on the animal" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        gen_saf_sto: {
            name: "Safe Storage",
            icon: gen_saf_sto,
            text: (
                <ul>
                    <ListItem text="Materials should be stored where they cannot fall on workers below." />
                    <ListItem text="Materials should be safely stacked" />
                    <ListItem text="Access routes for operatives and plant should be kept clear. Working areas must be kept clear. Ensure adequate space for access and loading activities." />
                    <ListItem text="Debris or excavated/extracted material should be regularly removed from the area." />
                </ul>
            )
        },
        gen_was_man: {
            name: "Waste Management",
            icon: gen_was_man,
            text: (
                <ul>
                    <ListItem text="Keep the site tidy." />
                    <ListItem text="There must be proper provision for binning municipal waste and this must be disposed off using authorised methods." />
                    <ListItem text="Distinguish reusable materials from materials suitable for recycling." />
                    <ListItem text="Ensure maximum segregation at source and avoid double handling." />
                    <ListItem text="Identify the best locations on site for stockpiling waste types." />
                    <ListItem text="Separate materials for recovery." />
                    <ListItem text="Agree pick-up arrangements and liaise with waste collection providers." />
                </ul>
            )
        },
        gen_lig: {
            name: "Lighting",
            icon: gen_lig,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            Adequate lighting levels and consistency must be
                            provided for operative access and work areas. For
                            guidance, minimum levels;
                        </Typography>
                        <ol>
                            <ListItem text="External circulation areas: 10 lx" />
                            <ListItem text="External Material handling areas: 10 lx" />
                            <ListItem text="Internal circulation areas: 5 lx" />
                            <ListItem text="Internal working areas: 15 lx" />
                            <ListItem text="Concreting: 50 lx" />
                            <ListItem text="Carpentry, joinery, blockwork, plastering: 100 lx" />
                            <ListItem text="Painting, decorating: 200 lx" />
                        </ol>
                        <Typography variant="title">
                            Total lumens = area (m2) x level (lx)/0.23
                            (utilisation)
                        </Typography>
                        <Typography variant="title">
                            Number of lights = total lumens/ lumen output of
                            light
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            If using tower lighting
                        </Typography>
                        <ol>
                            <ListItem text="Ensure ground is stable" />
                            <ListItem text="Ensure no contact with overhead lines" />
                            <ListItem text="Only erect tower lighting during daylight" />
                            <ListItem text="Protect from vehicle impact" />
                        </ol>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Adequate road lamps must be provided at roadworks
                            during hours of darkness in unlit areas{" "}
                        </Typography>
                        <ol>
                            <ListItem text="Steady state lamps along tapers (every 2nd cone)" />
                            <ListItem text="Steady state lamps or rotating reflectors along longitudinal cone runs (every 2nd cone)" />
                            <ListItem text="Flashing lamps are used only at points of danger" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        gen_de_gas_emp: {
            name: "De-Gassing / Empty / Clean",
            icon: gen_deg_pur,
            text: (
                <ul>
                    <ListItem text="Restricted openings relative to the size of the space will adversely affect the success of/ length of time required for this operation." />
                    <ListItem text="After completing this procedure, the atmosphere needs to be tested to check that it has been effective, and that it is safe to allow people to enter without breathing apparatus." />
                    <ListItem text="Cross ventilation should be maintained (particularly at the top and bottom of the space). Ongoing mechanical ventilation of fresh clean air into the space may also be required. Do not use oxygen as it will create a fire/ explosion hazard along with being potentially toxic itself." />
                </ul>
            )
        },
        gen_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: gen_sit_spe_met,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};
export default json;
